/* eslint-disable */
import React, { useContext, useEffect, useState } from 'react';
import { IUserAuth } from '../interfaces/IUserAuth';
import { IAuthAWS } from '../interfaces/IAuthAWS';
import {
  IAuthFunctionalities,
  SocialMedia,
} from '../interfaces/IAuthFunctionalities';
// import { DefaultTheme } from "react-native-paper";
import * as cognito from '../libs/cognito';
import { initGlobalConfig } from '../core/theme';
import { IMessage } from '../interfaces/IMessage';
import sendMessage from '../core/flash-message';
import { AuthStatus, IAuth } from '../interfaces/IAuth';
import { useAddLogMutation, useGetMeMutation } from '../../../apis/CommonApi';
import { CurrentUser, UserRoles } from '../../../types/User';
import { extractUserRole } from '../../../utils/User';

const defaultState: IAuth = {
  member: {
    username: '',
    userId: '',
  },
  sessionInfo: {},
  authStatus: AuthStatus.Loading,
  setPasswordAdvance: () => {},
  setEmail: () => {},
  setPhone: () => {},
  setName: () => {},
  setStateLocation: () => {},
  setSurname: () => {},
  setZip: () => {},
  setGender: () => {},
  setDob: () => {},
  setSpecialty: () => {},
  setPractice: () => {},
  setRole: () => {},
  getMFAOption: async () => {},
  setMFAOption: async () => {},
};

export const AuthContext = React.createContext(defaultState);

export const AuthIsSignedIn: React.FunctionComponent = ({ children }: any) => {
  const { authStatus }: IAuth = useContext(AuthContext);
  return <>{authStatus === AuthStatus.SignedIn ? children : null}</>;
};

export const AuthIsNotSignedIn: React.FunctionComponent = ({
  children,
}: any) => {
  const { authStatus }: IAuth = useContext(AuthContext);
  return <>{authStatus === AuthStatus.SignedOut ? children : null}</>;
};

interface IProps {
  config: IAuthAWS;
  // theme?: (ITheme & Theme) | undefined;
  authConfig?: IAuthFunctionalities;
}

const AuthProvider: React.FC<IProps> = (props: any) => {
  const [authStatus, setAuthStatus] = useState(AuthStatus.Loading);
  const [sessionInfo, setSessionInfo] = useState({});
  const [attrInfo, setAttrInfo] = useState([]);
  const [mfaRequired, setMfaRequired] = useState(false);
  const [globalConfig, setGlobalConfig] = useState({});

  const [isMultifactor, setIsMultifactor] = React.useState(false);

  //profile statewhile singup
  const [passwordAdvance, setPasswordAdvance] = useState('');
  const [email, setEmail] = useState('');
  const [gender, setGender] = useState('');
  const [zip, setZip] = useState('');
  const [dob, setDob] = useState<Date>();
  const [phone, setPhone] = useState('');
  const [surname, setSurname] = useState('');
  const [name, setName] = useState('');
  const [stateLocation, setStateLocation] = useState('');
  const [practice, setPractice] = useState('');
  const [specialty, setSpecialty] = useState('');
  const [role, setRole] = useState('');

  const initialTheme = {
    // ...DefaultTheme,
    ...props.theme,
  };

  /*
  **
  chime needed part
  **
  */
  const [member, setMember] = useState({
    username: '',
    userId: '',
  });
  // Auth state
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  // isAnonymous (anon does not have access to write to S3 for attachments) default to cognito flow
  const [isAnonymous, setAnonymous] = useState(false);
  // Using CognitoIdp (if true use Cognito IDP to search for users when adding members to a room,
  // else lookup using ListAppInstanceUsers API), default to Cognito flow
  const [useCognitoIdp, setUseCognitoIdp] = useState(true);
  /*
  **
  End of chime needed part
  **
  */

  const getSession = async () => {
    try {
      return await cognito.getSession();
    } catch (err) {
      throw err;
    }
  };

  const getAttributes = async () => {
    try {
      const attr = await cognito.getAttributes();
      return attr;
    } catch (err) {
      throw err;
    }
  };

  const getCurrentUser = async () => {
    const currentUser = await cognito.getCurrentUser();
    return currentUser;
  };
  const refreshToken = async (username: string) => {
    try {
      const refreshT = await getData('refreshToken');
      if (refreshT) return await cognito.refreshToken(username, refreshT);
      else {
        signOut();
        removeData('user');
      }
    } catch (err) {
      throw err;
    }
  };

  const [getMeMutation] = useGetMeMutation();
  const [addLogTrigger] = useAddLogMutation();

  const getSessionInfo = async () => {
    if (window.location.pathname.includes('smart-launch')) {
      setAuthStatus(AuthStatus.SignedIn);
      return;
    }

    try {
      const session: any = await getSession();
      if (session) prepareSessionInfo(session);
    } catch (err) {
      setAuthStatus(AuthStatus.SignedOut);
    }
  };

  const prepareSessionInfo = async (session: any) => {
    setSessionInfo({
      accessToken: session.accessToken.jwtToken,
      refreshToken: session.refreshToken.token,
      idToken: session.idToken.jwtToken,
    });

    await storeData('accessToken', session.accessToken.jwtToken);
    await storeData('refreshToken', session.refreshToken.token);
    await storeData('idToken', session.idToken.jwtToken);
    const user = await getMeMutation().unwrap();
    checkAdminAccess(user);
    checkDisabledAccount(user);
    setAuthStatus(AuthStatus.SignedIn);
    setIsAuthenticated(true);
  };

  const checkAdminAccess = (user: CurrentUser) => {
    // If user is not admin and is using the admin panel, redirect to web app
    if (window.location.host.includes('admin')) {
      const role = extractUserRole(user);
      if (
        role !== UserRoles.SUPER_ADMIN &&
        role !== UserRoles.ORG_OWNER &&
        role !== UserRoles.CODER
      ) {
        signOut();
        window.location.replace('https://webapp.galeai.co/');
      }
    }
  };

  const checkDisabledAccount = (user: CurrentUser) => {
    if (!user.active) {
      signOut();
      window.location.replace('/');
    }
  };

  useEffect(() => {
    /*
    **
    Configurable params initialization for cognito
    **
    */
    try {
      cognito.initCognito(props.config);
    } catch (error: any) {
      const message: IMessage = {
        message: error.code,
        description: `Ooops something wrong in the process: ${error.message}`,
        type: 'danger',
      };
      sendMessage(message);
    }

    /*
    **
    Default theme and authentication config initialization
    **
    */
    const initialConfig = initGlobalConfig(props.authConfig);
    setGlobalConfig({
      ...globalConfig,
      theme: initialTheme,
      authConfig: initialConfig,
      config: props.config,
    });

    /*
    **
    Cognito session initialization
    **
    */

    getSessionInfo();
  }, []);

  if (authStatus === AuthStatus.Loading) {
    return null;
  }

  const signInWithEmail = async (
    username: string,
    password: string,
    callback: () => void
  ) => {
    try {
      const session: any = await cognito.signInWithEmail(
        username,
        password,
        callback,
        setMfaRequired
      );
      if (session) {
        await prepareSessionInfo(session);
        if (!window.location.host.includes('admin')) {
          void addLogTrigger('Login (web)');
        }
      }
      return session;
    } catch (err) {
      setAuthStatus(AuthStatus.SignedOut);
      throw err;
    }
  };

  const respondToCustomChallenge = async (
    username: string,
    challengeResponse: string
  ) => {
    try {
      const session: any = await cognito.respondToCustomChallenge(
        username,
        challengeResponse
      );
      if (session) {
        await prepareSessionInfo(session);
        if (!window.location.host.includes('admin')) {
          void addLogTrigger('Login (web)');
        }
      }
      return session;
    } catch (err) {
      setAuthStatus(AuthStatus.SignedOut);
      throw err;
    }
  };

  const signInOTP = async (username: string, password: string) => {
    try {
      await cognito.signInOTP(username, password);
      setIsAuthenticated(true);
      return setAuthStatus(AuthStatus.SignedIn);
    } catch (err) {
      setAuthStatus(AuthStatus.SignedOut);
      throw err;
    }
  };

  const updatePhone = async (phone: string, username: string) => {
    try {
      return await cognito.updatePhone(phone, username);
    } catch (err) {
      throw err;
    }
  };

  const signInOTPNotRedirec = async (username: string, password: string) => {
    try {
      await cognito.signInOTP(username, password);
      return setAuthStatus(AuthStatus.SignedOut);
    } catch (err) {
      setAuthStatus(AuthStatus.SignedOut);
      throw err;
    }
  };

  const federatedSignIn = async (
    configAWS: IAuthAWS,
    provider: SocialMedia
  ) => {
    try {
      return cognito.federatedSignIn(configAWS, provider);
    } catch (err) {
      setAuthStatus(AuthStatus.SignedOut);
      throw err;
    }
  };

  const signUpWithEmail = async (
    username: string,
    email: string,
    password: string
  ) => {
    try {
      return await cognito.signUpUserWithEmail(username, email, password);
    } catch (err) {
      throw err;
    }
  };

  const signUpAdmin = async (username: string) => {
    try {
      return await cognito.signUpAdmin(username);
    } catch (err) {
      throw err;
    }
  };

  const adminDisableUser = async (username: string) => {
    try {
      return await cognito.disableUser(username);
    } catch (err) {
      throw err;
    }
  };

  const adminEnableUser = async (username: string) => {
    try {
      return await cognito.enableUser(username);
    } catch (err) {
      throw err;
    }
  };

  const getMFAOption = async () => {
    try {
      return await cognito.getMFAOption();
    } catch (err) {
      throw err;
    }
  };

  const setMFAOption = async (mfaOption: boolean) => {
    try {
      return await cognito.setMFAOption(mfaOption);
    } catch (err) {
      throw err;
    }
  };

  const signUpWithPhone = async ({
    username,
    email,
    password,
    phone_number,
    state,
    firstName,
    lastName,
  }: IUserAuth) => {
    try {
      const phoneNumber =
        phone_number !== '' ? `+1${phone_number}` : `+1${phone}`;
      return await cognito.signUpUserWithPhone(
        username,
        email,
        password,
        name,
        phoneNumber,
        practice,
        specialty,
        role,
        state
      );
    } catch (err) {
      throw err;
    }
  };

  function signOut() {
    cognito.signOut();
    localStorage.clear();
    setIsAuthenticated(false);
    setAuthStatus(AuthStatus.SignedOut);
  }

  const verifyCode = async (username: string, code: string) => {
    try {
      return await cognito.verifyCode(username, code);
    } catch (err) {
      throw err;
    }
  };

  const setAttribute = async (attr: any) => {
    try {
      return await cognito.setAttribute(attr);
    } catch (err) {
      throw err;
    }
  };

  const setAttributes = async (attr: IUserAuth) => {
    try {
      return await cognito.setAttributes(attr);
    } catch (err) {
      throw err;
    }
  };

  const sendCodeRecoverPassword = async (username: string) => {
    try {
      return await cognito.sendCodeRecoverPassword(username);
    } catch (err) {
      throw err;
    }
  };

  const sendCode = async (username: string, code: string) => {
    try {
      return await cognito.sendCode(username, code);
    } catch (err) {
      throw err;
    }
  };

  const sendMfaCode = async (username: string, code: string) => {
    try {
      await cognito.sendMfaCode(username, code);
      setMfaRequired(false);
      return true;
    } catch (err) {
      throw err;
    }
  };

  const reSendCode = async (username: string) => {
    try {
      return await cognito.reSendCode(username);
    } catch (err) {
      throw err;
    }
  };

  const reSendMfaCode = async (callback: (sended: boolean) => void) => {
    try {
      return await cognito.reSendMfaCode(callback);
    } catch (err) {
      throw err;
    }
  };

  const enableMFA = async (username: string) => {
    try {
      return await cognito.enableMFA(username);
    } catch (err) {
      throw err;
    }
  };

  const disableMFA = async (username: string) => {
    try {
      return await cognito.disableMFA(username);
    } catch (err) {
      throw err;
    }
  };

  const forgotPassword = async (
    username: string,
    code: string,
    password: string
  ) => {
    try {
      return await cognito.forgotPassword(username, code, password);
    } catch (err) {
      throw err;
    }
  };

  const forgotPasswordToken = async (username: string, password: string) => {
    try {
      return await cognito.forgotPasswordToken(username, password);
    } catch (err) {
      throw err;
    }
  };

  const onChangePhoneSubmitted = async (phone: string, email: string) => {
    try {
      return await cognito.onChangePhoneSubmitted(phone, email);
    } catch (err) {
      throw err;
    }
  };

  const onChangeEmailSubmitted = async (newEmail: string, email: string) => {
    try {
      return await cognito.onChangeEmailSubmitted(newEmail, email);
    } catch (err) {
      throw err;
    }
  };

  const changePassword = async (oldPassword: string, newPassword: string) => {
    try {
      return await cognito.changePassword(oldPassword, newPassword);
    } catch (err) {
      throw err;
    }
  };

  const completeNewPassword = async (
    username: string,
    password: string,
    newPassword: string
  ) => {
    try {
      return await cognito.completeNewPassword(username, password, newPassword);
    } catch (err) {
      console.log(err);
      throw err;
    }
  };

  const rememberDevice = async () => {
    try {
      return await cognito.rememberDevice();
    } catch (err) {
      throw err;
    }
  };

  const forgotDevice = async () => {
    try {
      return await cognito.forgotDevice();
    } catch (err) {
      throw err;
    }
  };

  const onConfirmCodeResendCodePhone = async (phone: string, email: string) => {
    try {
      return await cognito.onConfirmCodeResendCodePhone(phone, email);
    } catch (err) {
      throw err;
    }
  };

  const onConfirmCodeSubmitted = async (
    code: string,
    newEmail: string,
    email: string
  ) => {
    try {
      return await cognito.onConfirmCodeSubmitted(code, newEmail, email);
    } catch (err) {
      throw err;
    }
  };

  const onConfirmCodeSubmittedPhone = async (
    code: string,
    phone: string,
    email: string
  ) => {
    try {
      return await cognito.onConfirmCodeSubmittedPhone(code, phone, email);
    } catch (err) {
      throw err;
    }
  };

  const state: IAuth = {
    member: member,
    isAuthenticated: isAuthenticated,
    isAnonymous: isAnonymous,
    useCognitoIdp: useCognitoIdp,
    authStatus,
    sessionInfo,
    attrInfo,
    mfaRequired,
    globalConfig,
    isMultifactor,
    passwordAdvance,
    email,
    stateLocation,
    surname,
    zip,
    name,
    specialty,
    role,
    practice,
    dob,
    gender,
    phone,
    setPhone,
    setName,
    setStateLocation,
    setSurname,
    setSpecialty,
    setPractice,
    setRole,
    setZip,
    setGender,
    setDob,
    setEmail,
    setPasswordAdvance,
    signUpWithEmail,
    signInWithEmail,
    signUpWithPhone,
    signInOTP,
    signInOTPNotRedirec,
    signOut,
    verifyCode,
    getSession,
    sendCode,
    forgotPassword,
    changePassword,
    getAttributes,
    getCurrentUser,
    setAttribute,
    setAttributes,
    enableMFA,
    disableMFA,
    reSendCode,
    updatePhone,
    sendCodeRecoverPassword,
    respondToCustomChallenge,
    getMFAOption,
    setMFAOption,
    sendMfaCode,
    reSendMfaCode,
    federatedSignIn,
    rememberDevice,
    forgotDevice,
    signUpAdmin,
    adminDisableUser,
    adminEnableUser,
    forgotPasswordToken,
    storeData,
    onChangePhoneSubmitted,
    onChangeEmailSubmitted,
    refreshToken,
    completeNewPassword,
    setIsMultifactor,
    onConfirmCodeSubmittedPhone,
    onConfirmCodeResendCodePhone,
    onConfirmCodeSubmitted,
  };

  return (
    <AuthContext.Provider value={state}>{props.children}</AuthContext.Provider>
  );
};

export const useAuthContext = (): IAuth => {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error('useAuthContext must be used within AuthProvider');
  }

  return context;
};

export const storeData = async (key: string, value: string) => {
  try {
    localStorage.setItem(key, value);
  } catch (e) {
    throw e;
    // saving error
  }
};

export const getData = async (key: string) => {
  try {
    const value = localStorage.getItem(key);
    if (value !== null) {
      return value;
    }
  } catch (e) {
    throw e;
    // error reading value
  }
};

export const removeData = async (key: string) => {
  try {
    localStorage.removeItem(key);
  } catch (e) {
    throw e;
    // error reading value
  }
};

export default AuthProvider;
